import { ConsoleEventLogTypes } from "./consoleEventLog.types";
import axios from "axios";
import { config, getAccessToken } from "../../auth/auth";

const host = process.env.REACT_APP_HOST

export const search  = (queryParams) =>{
  const config = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json'
    },
    params: queryParams
  }

  return async dispatch => {
    return axios.get(`${host}/consoleEventLog`, config)
      .then(
        response => dispatch(setConsoleEventLogs(response.data)),
        err => console.log(err)
      );
  }
}

export const setConsoleEventLogs = (payload) => ({
  type: ConsoleEventLogTypes.SET_CONSOLEEVENTLOGS,
  payload: payload,
});